import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const advertisementsService = {
  Get,
  ContentGet,
  AdminGet,
  UnreadGet,
  AdminAdd,
  AdminEdit,
  AdminDel,
  ReadConfirm
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'advnotify'
};

function extract(r) {
  return r.data;
}

async function Get() {
  return axios.get(`${model.baseUrl}${model.controller}/Get`).then(extract);
}
async function ContentGet(advertisementId: number) {
  return axios.get(`${model.baseUrl}${model.controller}/ContentGet?advertisementId=${advertisementId}`).then(extract);
}

async function AdminGet(type : number) {
  return axios.get(`${model.baseUrl}${model.controller}/AdminGet?type=${type}`).then(extract);
}

async function UnreadGet() {
  return axios.get(`${model.baseUrl}${model.controller}/UnreadGet`).then(extract);
}

async function AdminAdd(title: string, content: string, orderIndex: number, showUserAlert: number, showStartDate: string, showEndDate: string) {
  return axios.put(`${model.baseUrl}${model.controller}/AdminAdd`, { title, content, orderIndex, showUserAlert, showStartDate, showEndDate });
}

async function AdminEdit(advertisementId: number, title: string, content: string, orderIndex: number, showUserAlert: number, showStartDate: string, showEndDate: string) {
  return axios.post(`${model.baseUrl}${model.controller}/AdminEdit`, { advertisementId, title, content, orderIndex, showUserAlert, showStartDate, showEndDate });
}

async function AdminDel(advertisementId: number[]) {
  return axios.delete(`${model.baseUrl}${model.controller}/AdminDel`, { data: advertisementId });
}

async function ReadConfirm(advertisementId: number) {
  return axios.post(`${model.baseUrl}${model.controller}/ReadConfirm?advertisementId=${advertisementId}`);
}
